import { Switch, SwitchProps } from '@mantine/core';
import { CenteredLoading } from 'components/CenteredLoading';

interface Props {
  isLoading: boolean;
}

export const TableSwitch = ({ isLoading, ...props }: Props & SwitchProps) => {
  if (isLoading) return <CenteredLoading />;

  return <Switch {...props} />;
};
